/**
 * Removes spaces around B2BSid search string
 */
export default b2bId => (query) => {
  const filters = query.queryStringParams.filters;
  filters.b2b = [b2bId];

  return query;
};
